import React, { Component } from 'react';
import './NotFound.css';
import { Link } from 'react-router-dom';
import {Button, Result} from 'antd';

class UnderDevelopment extends Component {
    render() {
        return (
            <Result
                status="500"
                title="Üzgünüz, sistem geliştirme aşamasındadır."
                subTitle=""
                extra={<Link to="/"><Button type="primary">Geri Dön</Button></Link>}
            />
        );
    }
}

export default UnderDevelopment;


// WEBPACK FOOTER //
// ./src/common/UnderDevelopment.js